import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class OpHoursNotificationModal extends React.Component {
  componentDidMount () {
    const { bookingId = '', reason = '' } = this.props;
    analyticsIntegrations.declineConfirmation(bookingId, reason);
  }

  render () {
    const { onClose, spaceId = '' } = this.props;
    return (
      <BootstrapModal
        onClose={onClose}
        modalClass="block-day-notification-modal"
        showModal
        banner={{
          type: 'success',
          text:
            <ul className="list-inline">
              <li className="v-center"><i className="ico ico-lg icon-yes" /></li>
              <li className="v-center">
                <FormattedMessage
                  id="inbox.op_hours_notification_modal.declined_request"
                  defaultMessage="You have declined the booking request"
                />
              </li>
            </ul>
        }}
        header={
          <div>
            <h3>
              <FormattedMessage
                id="inbox.op_hours_notification_modal.update_hours"
                defaultMessage="Update your Operating Hours"
              />
            </h3>
            <p>
              <FormattedMessage
                id="inbox.op_hours_notification_modal.operating_hours"
                defaultMessage="Your operating hours help guests know what times are available for bookings. Keeping an accurate calendar is a requirement for all hosts."
              />
            </p>
          </div>
        }
        body={
          <div className="text-center form-modal">
            <div>
              <a href={`/your-space/hours/edit?id=${spaceId}`} className="btn btn-block btn-primary classic">
                <FormattedMessage
                  id="inbox.op_hours_notification_modal.update_operating_hours"
                  defaultMessage="Update Operating Hours"
                />
              </a>
            </div>
          </div>
        }
        modalSize="sm-size"
      />
    );
  }
}

OpHoursNotificationModal.propTypes = {
  onClose: PropTypes.func,
  bookingId: PropTypes.string,
  reason: PropTypes.string,
  spaceId: PropTypes.string
};
